import React from 'react';
import { AIToolFinderQuiz } from '@/components/AIToolFinderQuiz';
import { SEOHead } from '@/components/SEOHead';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function QuizPage() {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="AI Tool Finder Quiz | Vergo"
        description="Answer 3 quick questions and get personalized AI tool recommendations. Find the perfect AI tool for your needs in under a minute."
        keywords="AI tool quiz, find AI tool, AI recommendation quiz, best AI for me"
      />
      <header className="border-b border-border bg-background sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors text-sm">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </header>
      <main className="container mx-auto px-4 py-12">
        <AIToolFinderQuiz />
      </main>
    </div>
  );
}
